import { Table } from "antd";
import { Button, Icon, Image } from "~/components";
import { renderDate } from "~/utils";

function SaleCallSourceTable({ items, pagination, onPaginationChange, setItemEdit, openModal }) {

	const columns = [
		{
			title: 'STT',
			key: 'stt',
			width: 60,
			render: (_, __, index) => (pagination.page - 1) * pagination.limit + index + 1,
		},
		{
			title: 'Tên bộ nguồn',
			dataIndex: 'name',
			key: 'name',
		},
		{ title: 'Người tạo', dataIndex: 'user', key: "user", render: (_, item) => (
			<>
				{
					item.user?.id &&
					<div className="d-flex gap align-items">
						<div className="avatar"><Image src={item.user?.avatar}/></div>
						<div>
							<b>{item.user?.firstname + ' ' + item.user?.lastname}</b>
						</div>
					</div>
				}
			</>
		)},
		{
			title: 'Tổng liên hệ',
			dataIndex: 'total',
			key: 'total',
			render: (total) => <b>{total}</b>,
		},
		{
			title: 'Tổng đã gọi',
			dataIndex: 'call',
			key: 'call',
			render: (call) => <b>{call}</b>,
		},
		{
			title: 'Ngày tạo',
			dataIndex: 'created',
			key: 'created',
			width: 130,
			render: (created) => renderDate(created),
		},
		{
			title: '',
			key: 'action',
			width: 100,
			render: (_, record) => (
				<div className="d-flex gap">
					<Button
						background
						small
						blue
						outline
						leftIcon={Icon.info}
						onClick={() => { setItemEdit(record); openModal('detail'); }}
					/>
					{/*<Button*/}
					{/*	background*/}
					{/*	small*/}
					{/*	red*/}
					{/*	leftIcon={Icon.delete}*/}
					{/*	onClick={() => { setItemEdit(record); openModal('delete'); }}*/}
					{/*/>*/}
				</div>
			),
		},
	];

	const handleTableChange = (pag) => {
		if (onPaginationChange) onPaginationChange(pag.current);
	};

	return (
		<Table
			columns={columns}
			dataSource={items}
			rowKey="id"
			pagination={{
				current: pagination.page,
				pageSize: pagination.limit,
				total: pagination.total,
				showTotal: (total) => `Tổng ${total} bộ nguồn`,
			}}
			onChange={handleTableChange}
		/>
	);
}

export default SaleCallSourceTable;

